import styled from 'styled-components';
import Colors from 'pubweb-smokey/dist/colors';

export const OwnAHomeStyles = styled.div`
  .preferred-contact {
    color: ${Colors.accent.grey1.standard};
    font-family: 'source-sans-pro', sans-serif;
    font-size: 16px;
    line-height: 1.69;
    margin-top: 10px;

    label {
      color: ${Colors.accent.grey1.standard};
      cursor: pointer;
      font-family: 'acumin-pro';
      margin-left: 5px;
    }
    input[type='radio'] {
      appearance: none;
      background-color: #fff;
      border: solid 1px ${Colors.accent.grey4.standard};
      border-radius: 50px;
      cursor: pointer;
      display: inline-block;
      height: 14px;
      margin-bottom: 3px;
      outline: none;
      position: relative;
      top: 4px;
      width: 14px;

      &:hover {
        border: solid 1px ${Colors.primary.claytonBlue.standard};
      }
      &:checked {
        border: solid 1px ${Colors.primary.claytonBlue.standard};
        background-color: ${Colors.primary.claytonBlue.standard};
      }
    }
    .radios {
      p {
        display: inline-block;
        width: 100px;
      }
    }
  }
  .help {
    color: ${Colors.accent.grey1.standard};
    cursor: pointer;
    font-family: 'acumin-pro', sans-serif;
    font-size: 12px;
    font-weight: 600;
    letter-spacing: -0.3px;
    line-height: 1.42;
    margin-top: -10px;
    position: relative;

    img {
      margin-bottom: -3px;
    }
  }
  .serial-no-field {
    margin-top: 20px;
  }
  .shared-form-fields-row {
    margin-top: 45px;
  }
  @media only screen and (min-width: 500px) {
    .preferred-contact {
      display: flex;
      justify-content: space-between;
    }
    .radios {
      p {
        text-align: right;
      }
    }
  }
`;

export default OwnAHomeStyles;
